module.exports = __webpack_public_path__ + "media/src/assets/img/elements/jbl-speaker-66807511376bd843f269ef71f9fba3e1.png";